import { useMemo, type ReactElement, type ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { useAuth } from '@/app/auth/context';
import { AdminShell } from '@/components/admin/AdminShell';
import { SkeletonRows } from '@/components/admin/states';

/**
 * 認証ガード。
 * これは導線の制御であって**セキュリティ境界ではない**（指示書 §0-6）。
 * 実際の可否は各 API が判定する。
 */
export function RequireAuth({ children }: { children: ReactNode }): ReactElement {
  const { user, isLoading, needsTotp } = useAuth();
  const location = useLocation();
  // 毎レンダーで新しいオブジェクトを渡すと Navigate の副作用が再実行され続けるため固定する
  const redirectState = useMemo(() => ({ from: location.pathname }), [location.pathname]);

  if (isLoading) {
    return (
      <div className="min-h-screen bg-wpcanvas px-4 py-6">
        <SkeletonRows rows={4} />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace state={redirectState} />;
  }

  if (needsTotp) {
    return <Navigate to="/totp" replace />;
  }

  return <AdminShell>{children}</AdminShell>;
}
